const COMMON_SPECIAL_DESIGNATIONS_MAP = {
  GENERAL: "0",
  FRONT_VIEW: "1",
  REAR_VIEW: "2",
  SALOON: "8",
};

const COMMON_SEAT_TYPES_NAME = {
  GENERAL: "一般席",
  FRONT_VIEW: "前展望席",
  REAR_VIEW: "後展望席",
};

const CAR_SPECIAL_DESIGNATIONS_MAP = {
  A: "A",
  B: "B",
  C: "C",
  D: "D",
  E: "E",
  F: "F",
  G: "G",
  H: "H",
  I: "I",
  J: "J",
};

const CAR_SPECIAL_DESIGNATIONS_LIST = [
  "1",
  "2",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
];

/**
 * 座席のステータス
 */
const SEAT_STATUS = {
  /** 満席 */
  FULL: "FULL",
  /** 残りわずか */
  LIMITED: "LIMITED",
  /** 余裕あり */
  AVAILABLE: "AVAILABLE",
};

/**
 * 一般席の残席判定閾値
 */
const GENERAL_SEAT_COUNT_THRESHOLDS = {
  /** 最小値 */
  MIN: 0,
  /** 「余裕あり」の最小値 */
  AVAILABLE_MIN: 100,
};

/**
 * 一般席以外の残席判定閾値
 */
const NOT_GENERAL_SEAT_COUNT_THRESHOLDS = {
  /** 最小値 */
  MIN: 0,
  /** 強制的に満席扱い（API側で定義されている） */
  FORCED_FULL: 999,
};

export {
  COMMON_SPECIAL_DESIGNATIONS_MAP,
  COMMON_SEAT_TYPES_NAME,
  CAR_SPECIAL_DESIGNATIONS_MAP,
  CAR_SPECIAL_DESIGNATIONS_LIST,
  SEAT_STATUS,
  GENERAL_SEAT_COUNT_THRESHOLDS,
  NOT_GENERAL_SEAT_COUNT_THRESHOLDS,
};
